module.exports = __webpack_public_path__ + "static/media/Karch_Livecooking_Einblender.d1636a10.jpg";